module.exports = __webpack_public_path__ + "static/media/Nikhil Veer.f9e74b84.webp";